module.exports = __webpack_public_path__ + "img/icon-amount-pellets-bigbag.0bf0955.svg";